module.exports = __webpack_public_path__ + "media/images/illustrations/starworks-diagram-7e5c28f184af36d6ce1508274d583c7b.svg";